export const countersFormat = (number) => {
	return Intl.NumberFormat("en-US", {
		style: 'decimal'
	}).format(number);
};
